import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TitleService {
  private title: BehaviorSubject<string> = new BehaviorSubject<string>('');

  constructor(
    private titleService: Title,
    private translateService: TranslateService
  ) {}

  public getTitle(): Observable<string> {
    return this.title.asObservable();
  }

  public setTitle(title: string): void {
    this.translateService.get(title).subscribe((translatedTitle) => {
      this.titleService.setTitle(translatedTitle);
      this.title.next(title);
    });
  }
}
